<template>
    <div class="container px-3">
      <label for="dataTable" class=" iot-station d-flex justify-content-start mb-3">Device Status</label>
      <table class="table table-bordered table-responsive">
        <thead class="table-light graph1-table">
          <tr>
            <th scope="col" width="200">Devices</th>
            <th scope="col" width="200">Devices Types</th>
            <th scope="col" width="200">Controllers</th>
            <th scope="col" width="200">IoT Hub</th>

          </tr>
        </thead>
        <tbody>
          <tr class="data-position">
            <td><span class="data-position-left">Total</span><span class="data-position-right"><strong>{{ devices.total
                  }}</strong></span></td>
            <td><span class="data-position-left">Total</span><span class="data-position-right"><strong>{{
              devicesTypes.total }}</strong></span></td>
            <td><span class="data-position-left">Total</span><span class="data-position-right"><strong>{{
              controllers.total }}</strong></span></td>
            <td><span class="data-position-left">Total</span><span class="data-position-right"><strong>{{ iotHubs.total
                  }}</strong></span></td>


          </tr>
          <tr class="data-position">
            <td><span class="data-position-left">Redundant</span><span
                class="data-position-right"><strong>-</strong></span></td>
            <td><span class="data-position-left">Online</span><span class="data-position-right"><strong>{{
              devicesTypes.online }}</strong></span></td>
            <td><span class="data-position-left">Online</span><span class="data-position-right"><strong>{{
              controllers.online }}</strong></span></td>
            <td><span class="data-position-left">Online</span><span class="data-position-right"><strong>{{ iotHubs.online
                  }}</strong></span></td>

          </tr>
          <tr class="data-position">
            <td><span class="data-position-left">Online</span><span class="data-position-right"><strong>{{
              devices.online }}</strong></span></td>
            <td><span class="data-position-left">Offline</span><span class="data-position-right"><strong>{{
              devicesTypes.offline }}</strong></span></td>

            <td><span class="data-position-left">Offline</span><span class="data-position-right"><strong>{{
              controllers.offline }}</strong></span></td>

            <td><span class="data-position-left">Offline</span><span class="data-position-right"><strong>{{
              iotHubs.offline }}</strong></span></td>

          </tr>
          <tr class="data-position">
            <td><span class="data-position-left">Offline</span><span class="data-position-right"><strong>{{
              devices.offline }}</strong></span></td>
            <td><span class="data-position-left">Other</span><span class="data-position-right"><strong>{{
              devicesTypes.other }}</strong></span></td>

            <td><span class="data-position-left">Other</span><span class="data-position-right"><strong>{{
              controllers.other }}</strong></span></td>

            <td><span class="data-position-left">Other</span><span class="data-position-right"><strong>{{
              iotHubs.other }}</strong></span></td>
          </tr>
          <tr class="data-position">
            <td><span class="data-position-left">Other</span><span class="data-position-right"><strong>{{ devices.other
                  }}</strong></span></td>
            <td></td>
            <td></td>
           <td><span class="data-position-left">DAC & GB</span><span class="data-position-right"><strong>{{ DacGb
                  }}</strong></span></td>
          </tr>
          <tr class="data-position">
            <td><span class="data-position-left">Active Alarm</span><span class="data-position-right"><strong>{{
              activeAlarms }}</strong></span></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="data-position">
            <td><span class="data-position-left">Total Yearly Alarm</span><span class="data-position-right"><strong>{{
              totalalarms }}</strong></span></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

        </tbody>
      </table>
    </div>
</template>
<script>
import { getDeviceStatus } from '@/http/dashboard/iot-insight.http'
export default {
  name: 'graph1',
  components: {
  },
  data() {
    return {
      devices: {},
      devicesTypes: {},
      controllers: {},
      iotHubs: {},
      activeAlarms: '',
      totalalarms: '',
      DacGb: '',
    }
  },
  mounted() {
    this.fetchDeviceStatusData()
    this.deviceStatusTimer = setInterval(() => {
      this.fetchDeviceStatusData()
    }, 10000);
  },
  beforeUnmount() {
    // Clear the deviceStatusTimer when the component is destroyed to prevent memory leaks
    clearInterval(this.deviceStatusTimer);
  },
  methods: {
    fetchDeviceStatusData() {
      getDeviceStatus().then((response) => {
        response.devicestatus.map((element) => {
          if (element.devicestatus === "Devices") {
            this.devices = element
          }
          if (element.devicestatus === "Devicetypes") {
            this.devicesTypes = element
          }
          if (element.devicestatus === "Controller") {
            this.controllers = element
          }
          if (element.devicestatus === "IotHub") {
            this.iotHubs = element
          }
        })
        this.activeAlarms = response.mapdevicestatus.activealarms
        this.totalalarms = response.mapdevicestatus.totalalarms
        this.DacGb = response.mapdevicestatus.dac
      }).catch((error) => {
        this.error = error.message;
      });
    }
  }


}
</script>
<style>
div table {
  font-size: 12px;
}
</style>